// extracted by mini-css-extract-plugin
export default {"optionLinkWrapper":"useAutocomplete_optionLinkWrapper__vs6U+"};